import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import PenIcon from '../icons/icon/PenIcon';

function PenEditButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} className="penEditBtn">
      <PenIcon />
    </button>
  );
}

PenEditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
PenEditButton.defaultProps = {};

export default translate(PenEditButton);
